import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 즉시 상단으로 스크롤
    window.scrollTo(0, 0);

    // 추가적으로 body와 html 요소도 상단으로 스크롤
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // 모바일 Safari를 위한 추가 처리
    if (document.body.scrollIntoView) {
      document.body.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;